import React, { useState } from 'react';

const ReviewStep2 = ({ formData, updateFormData, nextStep, prevStep }) => {
  const partyA = formData.partyA || {};
  const maritalHistory = partyA.maritalHistory || {};
  const [signature, setSignature] = useState(formData.partyASignature || '');

  const handleSignatureChange = (e) => {
    const value = e.target.value;
    setSignature(value);
    updateFormData({ partyASignature: value });
  };

  // Get the full name for Party A
  const getFullName = () => {
    const parts = [
      partyA.firstName,
      partyA.middleName,
      partyA.lastName,
      partyA.suffix
    ].filter(Boolean);
    return parts.join(' ');
  };

  // Get ordinal suffix for number (1st, 2nd, 3rd, etc.)
  const getOrdinal = (n) => {
    const num = parseInt(n) || 0;
    if (num === 0) return 'first';
    const s = ['th', 'st', 'nd', 'rd'];
    const v = num % 100;
    return num + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return (
    <div>
      <h1 className="form-section-title">{partyA.role || 'Party A'} - Signature</h1>

      <div className="review-section">
        <h3 className="form-subsection-title">Oath and Affirmation</h3>

        <div className="affirmation-panel">
          <p>
            I <strong>{getFullName() || '(print full name)'}</strong> do swear or affirm that the information
            contained in this application for marriage is true and correct. I further swear or affirm that this
            is my <strong>{getOrdinal((parseInt(maritalHistory.previousMarriages) || 0) + 1)}</strong> marriage but that I am
            not currently married to anyone else, and that I am free to marry under the laws of the State of
            Louisiana. I further understand and acknowledge that giving any false information or false statement
            in this application for marriage shall constitute the crime of filing a false public record in
            violation of the Louisiana Criminal Code (R.S. 14:133).
          </p>
        </div>

        <div className="form-field">
          <label className="form-label" htmlFor="partyA-signature">
            Digital Signature <span className="required">*</span>
          </label>
          <p className="form-help-text signature-help-text">
            Type your full legal name to electronically sign this affirmation.
          </p>
          <div className="signature-input-wrap">
            <input
              type="text"
              id="partyA-signature"
              className="form-input signature-input"
              value={signature}
              onChange={handleSignatureChange}
              placeholder="Type your full legal name"
              required
            />
          </div>
        </div>
      </div>

      <div className="step-navigation">
        <button onClick={prevStep} className="btn btn-secondary">Back</button>
        <button
          onClick={nextStep}
          className="btn btn-primary"
          disabled={!signature || signature.trim().length === 0}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ReviewStep2;
